import { Resources } from 'constants/resources';

import { useEffect } from 'react';

import { useGetOne } from 'react-admin';
import { useFormContext, useWatch } from 'react-hook-form';
import { User } from 'types/embedded/user';

export const useCopyMerchantAccesses = () => {
  const { setValue } = useFormContext();

  const sourceUserId = useWatch({ name: 'sourceUser' });
  const { data: sourceUser } = useGetOne<User>(
    Resources.Users,
    { id: sourceUserId },
    { enabled: !!sourceUserId },
  );

  useEffect(() => {
    const merchantIds =
      sourceUser?.merchantAccesses
        ?.map((merchantAccess) => merchantAccess?.merchant?.['@id'])
        ?.filter(Boolean) || [];

    if (!sourceUserId || !merchantIds.length) {
      return;
    }

    setValue('merchantIds', merchantIds, { shouldDirty: true });
  }, [sourceUserId, sourceUser, setValue]);
};
